module.exports = __webpack_public_path__ + "img/KH.92b839eb.svg";